import { BaseModel } from '@/api/base-model'
import { PipelinePhaseAPI } from '@/api/backend-client'
import { Pipeline } from '@/api/model/pipeline'
import { PipelinePhaseCategory } from '@/api/types'

export class PipelinePhase extends BaseModel<PipelinePhase> {
    protected collectionName = PipelinePhaseAPI.collectionName

    constructor(
        public pipeline: Pipeline|null,
        public id: string,
        public name: string,
        public category: PipelinePhaseCategory,
        public color: string,
        public sort: number,
        public active: boolean,
        public statusReasonRequired: boolean,
        public noStatusReasonEnabled: boolean,
        public createdAt: Date,
        public updatedAt: Date,
    ) { super(id) }

    compareTo(other: PipelinePhase): number {
        const categories = [
            PipelinePhaseCategory.ENTRY,
            PipelinePhaseCategory.APPROACH,
            PipelinePhaseCategory.DECISION,
        ]

        const thisCategoryIndex = categories.indexOf(this.category)
        const otherCategoryIndex = categories.indexOf(other.category)

        if (thisCategoryIndex !== otherCategoryIndex) {
            return thisCategoryIndex - otherCategoryIndex
        }

        return this.sort - other.sort
    }

    static fromData(data: any): PipelinePhase {
        if (data === null || typeof data === 'string' || data instanceof PipelinePhase) {
            return data
        }

        return new PipelinePhase(
            data.pipeline ? Pipeline.fromData(data.pipeline) : null,
            data.id,
            data.name,
            data.category,
            data.color,
            data.sort,
            data.active,
            data.statusReasonRequired,
            data.noStatusReasonEnabled,
            data.createdAt,
            data.updatedAt,
        )
    }
}
